import useMediaQuery from '@material-ui/core/useMediaQuery';
import { PeTypography } from '@pe-libs/react-components';
import PeHidden from '@pe-libs/react-components/build/components/PeHidden';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import { getPublicEnvironmentValue } from '@pe-libs/react-components/build/lib/environment';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FunctionComponent, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import { getUserLocale, selectIsEmployerHost } from '#modules/app/selectors';
import classNames from '#utils/classNames';
import LanguageSwitch from '../../../../components/languageSwitch';
import messages from './messages';
import PeContentAffiliate from './PeContentAffiliate';
import PeContentLayoutIntro from './PeContentLayoutIntro';
import PeContentLayoutLogo from './PeContentLayoutLogo';
import PeContentLayoutMarketingBanner, {
  Props as PeContentLayoutMarketingBannerProps,
} from './PeContentLayoutMarketingBanner';
import useStyles from './styles';

type Props = {
  contentTitle?: ReactNode;
  contentDesc?: ReactNode;
  marketingTitle?: PeContentLayoutMarketingBannerProps['title'];
  marketingDesc?: PeContentLayoutMarketingBannerProps['desc'];
  backgroundName: PeContentLayoutMarketingBannerProps['backgroundName'];
};

const PeContentLayout: FunctionComponent<Props> = ({
  contentTitle,
  contentDesc,
  marketingTitle,
  marketingDesc,
  backgroundName,
  children,
}) => {
  const styles = useStyles({ avatarUrl: '' });
  const isEmployerHost = useSelector(selectIsEmployerHost);
  const domain = getPublicEnvironmentValue('WWW_HOST', isEmployerHost);
  const formatMessage = useIntlMessage();
  const isDesktop = useMediaQuery('(min-width:960px)');
  const cookies = new Cookies();
  const locale = useSelector(getUserLocale)?.toLowerCase() ?? (cookies.get('registerlocale') as string);
  const isAffiliate = backgroundName === 'bgAffiliate';

  return (
    <div className={styles.mainContainer}>
      <div className={styles.sideContainer}>
        <div className={styles.langSwitchContainer}>
          <LanguageSwitch isHoverable={isDesktop} />
        </div>
        <div className={styles.sideContent}>
          <PeLink target="_blank" href={`${domain}/${locale}/`} title={formatMessage(messages.logoLinkTitle)}>
            <PeContentLayoutLogo />
          </PeLink>
          {isAffiliate && (
            <PeHidden smUp={true}>
              <div className={classNames(styles.bgAffiliate, styles.affiliateMobileLayout)}>
                <PeTypography variant="h4" color="inherit" gutterBottom={true}>
                  {marketingTitle}
                </PeTypography>
                <PeContentAffiliate />
                {marketingDesc}
              </div>
            </PeHidden>
          )}
          <PeContentLayoutIntro title={contentTitle} desc={contentDesc} />
          {children}
        </div>
      </div>
      <PeHidden xsDown={true}>
        <div className={styles.marketingSloganContainer}>
          <PeContentLayoutMarketingBanner backgroundName={backgroundName} title={marketingTitle} desc={marketingDesc} />
        </div>
      </PeHidden>
    </div>
  );
};

export default PeContentLayout;
